// Local storage utilities for Cover Letter data
const STORAGE_KEY = 'gradpath_cover_letter_data';

// Default cover letter data
export const defaultCoverLetterData = {
    personal: {
        fullName: 'Thabo Nkosi',
        email: 'thabo.nkosi@example.com',
        phone: '+27 12 345 6789',
        address: 'Johannesburg, South Africa'
    },
    recipient: {
        hiringManagerName: 'Hiring Manager',
        companyName: 'Example Company',
        companyAddress: 'Johannesburg, South Africa'
    },
    jobDetails: {
        jobTitle: 'Junior Software Developer',
        jobReference: ''
    },
    content: {
        opening: `I am writing to express my strong interest in the Junior Software Developer position at Example Company. As a recent Computer Science graduate from the University of Cape Town, I am excited about the opportunity to contribute to your innovative team.`,
        
        body: `During my studies, I developed strong technical skills in JavaScript, Python, and React. My internship experience at Tech Innovations SA allowed me to apply these skills in a professional environment, where I successfully contributed to the development of two major web applications. I particularly enjoyed collaborating with cross-functional teams and learning agile methodologies.

I am drawn to Example Company because of your commitment to innovation and excellence in the tech industry. Your recent project in AI-driven solutions aligns perfectly with my academic interests and career goals. I am eager to bring my problem-solving abilities, attention to detail, and passion for clean code to your development team.`,
        
        closing: `Thank you for considering my application. I look forward to the opportunity to discuss how my skills and enthusiasm can benefit your team. I am available for an interview at your earliest convenience.`
    },
    additional: {
        portfolio: 'https://github.com/thabonkosi',
        linkedin: 'https://linkedin.com/in/thabonkosi'
    }
};

// Save cover letter data to localStorage
export const saveCoverLetterData = (data) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        return true;
    } catch (error) {
        console.error('Error saving cover letter data:', error);
        return false;
    }
};

// Load cover letter data from localStorage
export const loadCoverLetterData = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            return JSON.parse(saved);
        }
        return defaultCoverLetterData;
    } catch (error) {
        console.error('Error loading cover letter data:', error);
        return defaultCoverLetterData;
    }
};

// Clear cover letter data
export const clearCoverLetterData = () => {
    localStorage.removeItem(STORAGE_KEY);
};